// extracted by mini-css-extract-plugin
export default {"wrapper":"MA-z","viewport":"NA-z","container":"OA-z","slide":"PA-z"};